import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScaleChecked } from '../../context/ScaleContext';
import { useJGraph } from './JGraphContext';
import JsCoupling from './JsCoupling';
export default function JsCouplings(props) {
    const { scaleX } = useScaleChecked();
    const { height } = useJGraph();
    return (_jsx("g", { className: "js-coupling", children: props.signals.map((signal) => {
            return (_jsxs("g", { transform: `translate(${scaleX()(signal.delta)},0)`, children: [_jsx("line", { x1: "0", y1: height, x2: "0", y2: "0", stroke: "black", strokeWidth: "1" }), signal.js?.map((j) => {
                        return _jsx(JsCoupling, { value: j.coupling }, `${j.coupling}`);
                    })] }, signal.id));
        }) }));
}
